export default "__VITE_ASSET__cmyckE2$__"